import { FC } from 'react';
import { Box, Divider, Typography, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { formatDate } from 'src/utils/format-date';
import { theme } from 'src/styles/theme';
import { getStorage } from 'src/utils/local-storage-versioning';
import { Room } from 'src/shared/types/room';

import { styles } from './styles';

interface BookingDetailsContentShortProps {
    roomData: Room;
    termDuration: number;
    termStartDate: string;
    termEndDate: string;
    numberOfStudents: number;
}

export const BookingDetailsContentShort: FC<BookingDetailsContentShortProps> = ({
    roomData,
    termDuration,
    termStartDate,
    termEndDate,
    numberOfStudents,
}) => {
    const { t } = useTranslation();
    const storage = getStorage();

    const { paymentPlanId = null } = storage.redirectState;
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));

    if (!termDuration || !termStartDate || !termEndDate || !numberOfStudents || !roomData)
        return null;

    const count = termDuration;
    const bookingLength =
        roomData.monthly_price && !paymentPlanId
            ? t('booking_summary_months_count', { count })
            : t('booking_summary_weeks_count', { count });
    const startDate = formatDate(termStartDate);
    const endDate = formatDate(termEndDate);
    const studentCount = numberOfStudents;
    const fontStyle = isSmallScreen ? 'h4' : 'h6';

    return (
        <Box css={!isSmallScreen && styles.bookingDetailsContainer}>
            {!isSmallScreen && <Divider css={styles.divider} />}
            <Box sx={styles.detailsRow}>
                <Box sx={styles.detailsColumnLeft}>
                    <Typography variant={fontStyle}>
                        {t('your_details_booking_students_count_long')}
                    </Typography>
                    <Typography variant={fontStyle}>{t('your_details_booking_length')}</Typography>
                    <Typography variant={fontStyle}>
                        {t('your_details_booking_start_date')}
                    </Typography>
                    <Typography variant={fontStyle}>
                        {t('your_details_booking_end_date')}
                    </Typography>
                </Box>
                <Box sx={styles.detailsColumnRight}>
                    <Typography variant={fontStyle}>{studentCount}</Typography>
                    <Typography variant={fontStyle}>{bookingLength}</Typography>
                    <Typography variant={fontStyle}>{startDate}</Typography>
                    <Typography variant={fontStyle}>{endDate}</Typography>
                </Box>
            </Box>
        </Box>
    );
};
